import React, { Component } from 'react';

// Holds a list's pagination above or below its table.
class Footer extends Component {
  render() {
    return (
      <nav className="bp3-navbar search list-pager">
        <div>
          {this.props.children}
        </div>
      </nav>
    )
  }
};

export default Footer;
